import { useQuery } from '@tanstack/react-query';
import { apiFetch } from '@/lib/api';
import type { UsersResponse } from '@/lib/types';

interface ListParams {
  page?: number;
  limit?: number;
  search?: string;
  organizationId?: string;
  role?: string;
  isActive?: boolean;
}

export function useUsers(params: ListParams = {}) {
  const queryParams = new URLSearchParams();
  if (params.page) queryParams.set('page', String(params.page));
  if (params.limit) queryParams.set('limit', String(params.limit));
  if (params.search) queryParams.set('search', params.search);
  if (params.organizationId) queryParams.set('organizationId', params.organizationId);
  if (params.role) queryParams.set('role', params.role);
  if (params.isActive !== undefined) queryParams.set('isActive', String(params.isActive));

  const queryString = queryParams.toString();
  const endpoint = `/v1/admin/users${queryString ? `?${queryString}` : ''}`;

  return useQuery({
    queryKey: ['users', params],
    queryFn: () => apiFetch<UsersResponse>(endpoint),
  });
}
